import React, { useState } from 'react'
import { Box, Radio, FormControl, RadioGroup, FormControlLabel, Typography } from '@mui/material'

import ConfirmDialog from '../../controls/ConfirmDialog'
import { connect } from '@cerebral/react'
import { sequences } from 'cerebral'

interface ServiceDismissModalTypes {
  id: string
  dismissServiceRequest: ({ id, minutes }: { id: string; minutes: number }) => void
  visible: boolean
  minutes?: number
  onClose?: () => void
}

const ServiceDismissModal = connect(
  {
    dismissServiceRequest: sequences`serviceRequests.dismissServiceRequest`,
  },
  ({ id, visible = false, onClose, dismissServiceRequest: dismiss }: ServiceDismissModalTypes) => {
    const [delayMinutes, setDelayMinutes] = useState('10')

    return (
      <ConfirmDialog title="" open={visible} onClose={onClose} onConfirm={() => dismiss({ id, minutes: parseInt(delayMinutes) })} confirmText="Confirm">
        <Box mb={2} style={{ width: 400 }}>
          <FormControl>
            <Box mb={2}>
              <Typography variant="h5">Delay the request for:</Typography>
            </Box>
            <RadioGroup
              aria-labelledby="service-request-dismiss-interval"
              defaultValue="10"
              name="radio-buttons-group"
              onChange={({ target: { value } }) => setDelayMinutes(value)}
            >
              <FormControlLabel value={5} control={<Radio />} label="5 minutes" />
              <FormControlLabel value={10} control={<Radio />} label="10 minutes" />
              <FormControlLabel value={15} control={<Radio />} label="15 minutes" />
              <FormControlLabel value={30} control={<Radio />} label="30 minutes" />
              <FormControlLabel value={60} control={<Radio />} label="1 hour" />
            </RadioGroup>
          </FormControl>
        </Box>
      </ConfirmDialog>
    )
  }
)

export default ServiceDismissModal
